var _rect, _path, _rect2, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAxisIconround = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-1 0 0 1 48 0)",
    fill: "#FF4F17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1187 12H12V33.3611L18.6876 36V23.2576L29.4598 34.2488L34.2319 29.6409L22.4693 17.7377H36L33.1187 12Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#AE285D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0069 14.5527C25.1292 16.4807 26.2612 18.4031 27.3714 20.3384C25.577 23.5037 23.8085 26.6843 21.9534 29.8148C21.2416 31.0165 20.5493 32.2295 19.8456 33.4352C17.5637 33.449 15.2819 33.4482 13 33.4449C13.0696 33.2886 13.1385 33.1315 13.2227 32.9826C16.8155 26.8382 20.4221 20.7019 24.0069 14.5527Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0078 26.3068C26.2978 26.306 28.5877 26.2898 30.8777 26.3279C32.2413 28.7053 33.6486 31.0568 35.0001 33.4407C32.7102 33.452 30.421 33.4431 28.131 33.4415C26.7682 31.056 25.3447 28.7069 24.0078 26.3068Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAxisIconround, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/axisIconround.59147f60.svg";
export { ForwardRef as ReactComponent };